export const ROUTES = {
    default: '/',
    logout: '/logout',
    notFound: '/not-found',
    error: '/error',
    brokerManagers: '/broker-managers',
    agents: '/agents',
};
